import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NetworkService } from '../../../core/services/network.service';

@Component({
    selector: 'app-network-modal',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div class="network-modal-overlay" *ngIf="showModal">
      <div class="network-modal">
        <!-- Modal Header -->
        <div class="modal-header" [ngClass]="modalType">
          <div class="header-content">
            <div class="icon-container">
              <svg *ngIf="modalType === 'error'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
              </svg>
              <svg *ngIf="modalType === 'success'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
            <div class="header-text">
              <h3>{{ modalTitle }}</h3>
              <p class="header-subtitle" *ngIf="modalType === 'error'">No internet connection detected</p>
            </div>
          </div>
          
          <!-- Close button only for success modal -->
          <button class="close-btn" (click)="closeModal()" *ngIf="modalType === 'success'">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        
        <!-- Modal Body -->
        <div class="modal-body">
          <p class="message">{{ modalMessage }}</p>
          
          <!-- Connection Status Indicator -->
          <!-- <div class="connection-status">
            <div class="status-card">
              <div class="status-header">
                <span class="status-label">Current Status</span>
                <span class="last-checked">Last checked: just now</span>
              </div>
              <div class="status-indicator" [ngClass]="{ 'online': isOnline, 'offline': !isOnline }">
                <div class="status-dot-container">
                  <span class="status-dot"></span>
                  <span class="status-text">{{ isOnline ? 'Online' : 'Offline' }}</span>
                </div>
                <div class="status-details">
                  <span class="status-detail" *ngIf="isOnline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M5 12.55a11 11 0 0 1 14.08 0"></path>
                      <path d="M1.42 9a16 16 0 0 1 21.16 0"></path>
                      <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
                      <line x1="12" y1="20" x2="12.01" y2="20"></line>
                    </svg>
                    Connection stable
                  </span>
                  <span class="status-detail" *ngIf="!isOnline">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M1 1l22 22"></path>
                      <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path>
                      <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path>
                      <path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path>
                      <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path>
                      <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
                      <line x1="12" y1="20" x2="12.01" y2="20"></line>
                    </svg>
                    Connection lost
                  </span>
                </div>
              </div>
            </div>
          </div> -->
          
          <!-- Troubleshooting Steps (only when offline) -->
          <div class="troubleshooting" *ngIf="!isOnline">
            <h4 class="troubleshooting-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
              </svg>
              Troubleshooting Steps
            </h4>
            <div class="troubleshooting-steps">
              <div class="step">
                <div class="step-icon">1</div>
                <div class="step-content">
                  <h5>Check Wi-Fi or Mobile Data</h5>
                  <p>Ensure your Wi-Fi or mobile data is turned on and connected</p>
                </div>
              </div>
              <div class="step">
                <div class="step-icon">2</div>
                <div class="step-content">
                  <h5>Disable Airplane Mode</h5>
                  <p>Make sure airplane mode is disabled on your device</p>
                </div>
              </div>
              <div class="step">
                <div class="step-icon">3</div>
                <div class="step-content">
                  <h5>Restart Router/Modem</h5>
                  <p>Power cycle your network equipment and wait 30 seconds</p>
                </div>
              </div>
              <div class="step">
                <div class="step-icon">4</div>
                <div class="step-content">
                  <h5>Try Different Network</h5>
                  <p>Switch to another Wi-Fi network or use mobile data</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Modal Footer -->
        <!-- <div class="modal-footer">
          <div class="footer-actions">
            <button class="retry-btn" (click)="retryConnection()" *ngIf="!isOnline">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"></path>
              </svg>
              Check Connection Again
            </button>
            <button class="close-modal-btn" (click)="closeModal()" *ngIf="modalType === 'error'">
              Dismiss
            </button>
          </div>
        </div> -->
        
        <!-- Auto-close timer for success modal -->
        <div class="auto-close-timer" *ngIf="modalType === 'success'">
          <div class="timer-bar" [style.width.%]="timerProgress"></div>
        </div>
      </div>
    </div>
  `,
    styles: [`
    /* Base Styles */
    .network-modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.85);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
      backdrop-filter: blur(4px);
      animation: fadeIn 0.3s ease;
    }

    .network-modal {
      background: #292929;
      border-radius: 16px;
      width: 90%;
      max-width: 480px;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
      overflow: hidden;
      animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      position: relative;
      border: 1px solid rgba(255, 255, 255, 0.1);
    }

    /* Modal Header */
    .modal-header {
      padding: 24px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      position: relative;
    }

    .modal-header.error {
      background: linear-gradient(135deg, #292929 0%, rgba(239, 74, 0, 0.15) 100%);
      border-bottom: 1px solid rgba(239, 74, 0, 0.3);
    }

    .modal-header.success {
      background: linear-gradient(135deg, #292929 0%, rgba(91, 215, 99, 0.15) 100%);
      border-bottom: 1px solid rgba(91, 215, 99, 0.3);
    }

    .header-content {
      display: flex;
      align-items: flex-start;
      gap: 16px;
      flex: 1;
    }

    .icon-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      border-radius: 12px;
      flex-shrink: 0;
    }

    .modal-header.error .icon-container {
      background: rgba(239, 74, 0, 0.2);
      color: #EF4A00;
    }

    .modal-header.success .icon-container {
      background: rgba(91, 215, 99, 0.2);
      color: #5BD763;
    }

    .header-text {
      flex: 1;
    }

    .modal-header h3 {
      margin: 0 0 4px 0;
      font-size: 20px;
      font-weight: 600;
      color: #ffffff;
      letter-spacing: -0.01em;
    }

    .header-subtitle {
      margin: 0;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      font-weight: 400;
    }

    .close-btn {
      background: rgba(255, 255, 255, 0.1);
      border: none;
      width: 36px;
      height: 36px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.8);
      transition: all 0.2s ease;
      flex-shrink: 0;
      margin-left: 12px;
    }

    .close-btn:hover {
      background: rgba(255, 255, 255, 0.15);
      color: #ffffff;
      transform: translateY(-1px);
    }

    /* Modal Body */
    .modal-body {
      padding: 24px;
    }

    .message {
      margin: 0 0 24px 0;
      color: rgba(255, 255, 255, 0.9);
      line-height: 1.6;
      font-size: 15px;
      font-weight: 400;
    }

    /* Connection Status */
    .connection-status {
      margin-bottom: 24px;
    }

    .status-card {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 12px;
      padding: 16px;
      border: 1px solid rgba(255, 255, 255, 0.1);
    }

    .status-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }

    .status-label {
      font-size: 12px;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.6);
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }

    .last-checked {
      font-size: 11px;
      color: rgba(255, 255, 255, 0.4);
    }

    .status-indicator {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .status-dot-container {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .status-dot {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      display: inline-block;
      position: relative;
    }

    .status-indicator.online .status-dot {
      background: #5BD763;
      box-shadow: 0 0 0 4px rgba(91, 215, 99, 0.2);
      animation: pulseOnline 2s infinite;
    }

    .status-indicator.offline .status-dot {
      background: #EF4A00;
      box-shadow: 0 0 0 4px rgba(239, 74, 0, 0.2);
      animation: pulseOffline 2s infinite;
    }

    .status-text {
      font-weight: 600;
      color: #ffffff;
      font-size: 16px;
    }

    .status-details {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      color: rgba(255, 255, 255, 0.7);
    }

    .status-detail {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    /* Troubleshooting */
    .troubleshooting {
      background: rgba(255, 255, 255, 0.03);
      border-radius: 12px;
      padding: 20px;
      border: 1px solid rgba(255, 255, 255, 0.05);
    }

    .troubleshooting-title {
      margin: 0 0 16px 0;
      color: #ffffff;
      font-size: 15px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .troubleshooting-title svg {
      color: #2CC3E8;
    }

    .troubleshooting-steps {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    .step {
      display: flex;
      gap: 14px;
    }

    .step-icon {
      width: 28px;
      height: 28px;
      background: rgba(43, 112, 219, 0.15);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 700;
      color: #2CC3E8;
      flex-shrink: 0;
    }

    .step-content {
      flex: 1;
    }

    .step-content h5 {
      margin: 0 0 4px 0;
      color: #ffffff;
      font-size: 14px;
      font-weight: 600;
    }

    .step-content p {
      margin: 0;
      color: rgba(255, 255, 255, 0.6);
      font-size: 13px;
      line-height: 1.5;
    }

    /* Modal Footer */
    .modal-footer {
      padding: 20px 24px;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      background: rgba(255, 255, 255, 0.02);
    }

    .footer-actions {
      display: flex;
      gap: 12px;
    }

    .retry-btn {
      background: #2CC3E8;
      color: white;
      border: none;
      padding: 14px 24px;
      border-radius: 10px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 10px;
      transition: all 0.2s ease;
      flex: 1;
      justify-content: center;
    }

    .retry-btn:hover {
      background: #1E5FC4;
      transform: translateY(-1px);
      box-shadow: 0 6px 20px rgba(43, 112, 219, 0.3);
    }

    .close-modal-btn {
      background: rgba(255, 255, 255, 0.1);
      color: rgba(255, 255, 255, 0.9);
      border: 1px solid rgba(255, 255, 255, 0.2);
      padding: 14px 24px;
      border-radius: 10px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;
      flex: 1;
    }

    .close-modal-btn:hover {
      background: rgba(255, 255, 255, 0.15);
      border-color: rgba(255, 255, 255, 0.3);
    }

    /* Auto-close Timer */
    .auto-close-timer {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 4px;
      background: rgba(255, 255, 255, 0.1);
    }

    .timer-bar {
      height: 100%;
      background: linear-gradient(90deg, #5BD763 0%, rgba(91, 215, 99, 0.6) 100%);
      transition: width 0.3s ease;
      border-radius: 0 0 16px 16px;
    }

    /* Animations */
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    @keyframes slideUp {
      from {
        opacity: 0;
        transform: translateY(30px) scale(0.95);
      }
      to {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }

    @keyframes pulseOnline {
      0% { box-shadow: 0 0 0 0 rgba(91, 215, 99, 0.4); }
      70% { box-shadow: 0 0 0 6px rgba(91, 215, 99, 0); }
      100% { box-shadow: 0 0 0 0 rgba(91, 215, 99, 0); }
    }

    @keyframes pulseOffline {
      0% { box-shadow: 0 0 0 0 rgba(239, 74, 0, 0.4); }
      70% { box-shadow: 0 0 0 6px rgba(239, 74, 0, 0); }
      100% { box-shadow: 0 0 0 0 rgba(239, 74, 0, 0); }
    }

    /* Responsive Design */
    @media (max-width: 480px) {
      .network-modal {
        width: 95%;
        margin: 0 10px;
      }
      
      .modal-header {
        padding: 20px;
      }
      
      .modal-body {
        padding: 20px;
      }
      
      .modal-footer {
        padding: 16px 20px;
      }
      
      .footer-actions {
        flex-direction: column;
      }
      
      .icon-container {
        width: 40px;
        height: 40px;
      }
      
      .modal-header h3 {
        font-size: 18px;
      }
    }
  `]
})
export class NetworkModalComponent implements OnInit, OnDestroy {
    showModal = false;
    modalTitle = '';
    modalMessage = '';
    modalType: 'error' | 'success' = 'error';
    isOnline = true;
    timerProgress = 100;

    private subscriptions: Subscription[] = [];
    private timerInterval?: any;

    constructor(private networkService: NetworkService) { }

    ngOnInit(): void {
        this.subscriptions.push(
            this.networkService.showModal$.subscribe(show => {
                this.showModal = show;
            }),

            this.networkService.modalTitle$.subscribe(title => {
                this.modalTitle = title;
            }),

            this.networkService.modalMessage$.subscribe(message => {
                this.modalMessage = message;
            }),

            this.networkService.modalType$.subscribe(type => {
                this.modalType = type;
                if (type === 'success') {
                    this.startTimer();
                } else {
                    this.stopTimer();
                }
            }),

            this.networkService.onlineStatus$.subscribe(status => {
                this.isOnline = status;
            })
        );

        this.isOnline = this.networkService.isOnline;
    }

    private startTimer(): void {
        this.stopTimer();
        const duration = 3000;
        const interval = 50;
        let elapsed = 0;

        this.timerInterval = setInterval(() => {
            elapsed += interval;
            this.timerProgress = 100 - (elapsed / duration * 100);

            if (elapsed >= duration) {
                this.stopTimer();
                this.closeModal();
            }
        }, interval);
    }

    private stopTimer(): void {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = undefined;
            this.timerProgress = 100;
        }
    }

    closeModal(): void {
        this.networkService.hideModal();
    }

    retryConnection(): void { 
        const retryBtn = document.querySelector('.retry-btn') as HTMLElement;
        if (retryBtn) {
            retryBtn.style.transform = 'scale(0.95)';
            setTimeout(() => {
                retryBtn.style.transform = '';
            }, 200);
        }
 
        const currentStatus = this.networkService.checkNetworkStatus();
        this.isOnline = currentStatus;

        if (currentStatus) {
            this.networkService.showNetworkModal(
                'Connection Restored',
                'Your internet connection has been successfully restored.',
                'success'
            );
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.stopTimer();
    }
}